<template>
  <div class="modal" :class="{ show: isOpen }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="brand-logo">
            <div class="brand-logo-inner">
              <img src="@/assets/images/logo.png" alt="logo" class="logo">
            </div>
          </div>
          <button class="close" @click="() => close(false)">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="showSuccess" class="success-message">
            <i class="fas fa-check-circle"></i>
            感謝您的訂閱！我們將定期發送精選酒訊給您。
          </div>

          <p class="subtitle">
            我們尊重您的隱私，也想與您分享<br>
            值得收藏的酒訊。
          </p>

          <div class="cookie-notice">
            <span>為了提供您更優質的瀏覽體驗，我們的網站使用 cookies 及相關技術來分析網站流量、個人化內容與推薦，並協助我們優化服務。</span>
            <span>我們可能會收集您在瀏覽本網站時的部分資訊（如瀏覽行為、設備類型、IP 位址等），以便改善網站功能，並為您帶來更貼近興趣的內容與推薦。這些資訊可能會透過第三方工具（如 Google
              Analytics）進行統計與分析。</span>
            <span>您可以選擇接受所有 cookies、只允許必要 cookies，或進一步自訂您的 cookie 偏好。<a target="_blank"
                href="https://docs.google.com/document/d/1C2yJxgeWNHES9j7wHtQ_nBFNP9C77pTfB_W5z5z88XM/edit?tab=t.0"
                class="highlight"><u>我們尊重您的隱私，並保證所有資料僅用於本政策所述之目的</u></a></span>。
          </div>
          <form @submit.prevent="submitForm">
            <div class="btn-group-custom">
              <button type="submit" class="btn-agree" :disabled="isSubmitting">
                <i class="fas fa-check"></i>
                我同意
              </button>
              <button type="button" class="btn-decline" @click="() => close(false)">
                <i class="fas fa-times"></i>
                僅限必要功能
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { ApiService } from '@/apis/service'
import ls from 'localstorage-slim'
const store = useStore()
const formData = ref({
  email: '',
  agreeNewsletter: false
})
const errors = ref({})
const showSuccess = ref(false)
const isSubmitting = ref(false)
const isOpen = computed(() => store.state.modal.isOpen)
const close = (isAgree = false) => {
  store.commit('setModal', false);
  ls.set('agreeCookie', isAgree ? 'true' : 'false')
}


const submitForm = async () => {
  isSubmitting.value = true
  close(true)
}

</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-dialog {
  max-width: 500px;
  width: 100%;
  margin: 0;
}

.modal-content {
  background: linear-gradient(135deg, rgba(44, 24, 16, 0.95), rgba(26, 15, 8, 0.95));
  border: none;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  color: white;
  position: relative;
  overflow: hidden;
  transform: scale(0.7);
  opacity: 0;
  transition: all 0.3s ease;
}

.modal.show .modal-content {
  transform: scale(1);
  opacity: 1;
}

.modal-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.modal-header {
  border-bottom: 2px solid rgba(212, 175, 55, 0.3);
  padding: 25px 30px 20px;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.brand-logo {}

.brand-logo-inner {
  margin: -60px 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 80%;
    height: 100%;
    object-fit: contain;
  }
}

.modal-title {
  color: white;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.modal-body {
  padding: 30px;
  position: relative;
  z-index: 1;
}

.subtitle {
  color: #b8a082;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 25px;
}

.cookie-notice {
  // background: rgba(76, 175, 80, 0.2);
  // border: 2px solid #4caf50;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 25px;
  font-size: 14px;
  // line-height: 2;
}

.cookie-notice .highlight {
  color: white;
  font-weight: bold;
}

.form-group label {
  color: #b8a082;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.form-control {
  background: rgba(212, 175, 55, 0.1);
  border: 2px solid rgba(212, 175, 55, 0.3);
  border-radius: 8px;
  color: white;
  padding: 12px 15px;
  font-size: 16px;
  transition: all 0.3s ease;
  width: 100%;
}

.form-control:focus {
  background: rgba(212, 175, 55, 0.15);
  border-color: white;
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.3);
  color: white;
  outline: none;
}

.form-control::placeholder {
  color: rgba(212, 175, 55, 0.6);
}

.custom-checkbox {
  margin: 20px 0;
  display: flex;
  align-items: center;
}

.custom-checkbox input[type="checkbox"] {
  margin-right: 10px;
  transform: scale(1.2);
}

.custom-checkbox label {
  color: #b8a082;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 0;
}

.btn-group-custom {
  display: flex;
  gap: 15px;
  margin-top: 25px;
}

.btn-agree {
  // background: linear-gradient(135deg, white, #b8941f);
  border: none;
  border-radius: 8px;
  color: #1a0f08;
  font-weight: bold;
  padding: 12px 30px;
  font-size: 16px;
  transition: all 0.3s ease;
  flex: 1;
  cursor: pointer;
}

.btn-agree:hover {
  // background: linear-gradient(135deg, #b8941f, #9d7d1a);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(212, 175, 55, 0.4);
  color: #1a0f08;
}

.btn-decline {
  background: transparent;
  border: 2px solid rgba(212, 175, 55, 0.5);
  border-radius: 8px;
  color: white;
  font-weight: bold;
  padding: 12px 30px;
  font-size: 16px;
  transition: all 0.3s ease;
  flex: 1;
  cursor: pointer;
}

.btn-decline:hover {
  background: rgba(212, 175, 55, 0.1);
  border-color: white;
  color: white;
  transform: translateY(-2px);
}

.close {
  color: white;
  opacity: 0.8;
  font-size: 28px;
  transition: all 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.close:hover {
  color: #fff;
  opacity: 1;
  transform: scale(1.1);
}

.demo-button {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, white, #b8941f);
  border: none;
  border-radius: 10px;
  color: #1a0f08;
  font-weight: bold;
  padding: 15px 30px;
  font-size: 18px;
  box-shadow: 0 10px 30px rgba(212, 175, 55, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.demo-button:hover {
  transform: translate(-50%, -50%) translateY(-3px);
  box-shadow: 0 15px 40px rgba(212, 175, 55, 0.4);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.error-message {
  color: #ff6b6b;
  font-size: 12px;
  margin-top: 5px;
}

.success-message {
  // background: rgba(76, 175, 80, 0.2);
  border: 1px solid #4caf50;
  color: #4caf50;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

@media (max-width: 576px) {
  .modal {
    padding: 10px;
  }

  .modal-body {
    padding: 20px;
  }

  .btn-group-custom {
    flex-direction: column;
  }
}
</style>
